const ar = {
    common: {
        save: 'حفظ',
        cancel: 'إلغاء',
        cancelUpper: 'إلغاء',
        delete: 'حذف',
        deleteUpper: 'حذف',
        edit: 'تعديل',
        confirm: 'تأكيد',
        close: 'إغلاق',
        loading: 'جارٍ التحميل...',
        error: 'حدث خطأ ما',
        requestFailed: 'حدث خطأ ما، يرجى المحاولة لاحقاً.',
        success: 'تم',
        okay: 'حسناً',
        submit: 'إرسال',
        notAvailable: 'غير متوفر',
        emptySection: 'لا يوجد محتوى للعرض، القسم فارغ',
    },
    cart: {
        subtotal: 'المجموع الفرعي:',
        total: 'الإجمالي:',
        empty: 'سلة التسوق فارغة',
        continueShopping: 'متابعة التسوق',
        sendViaWhatsapp: 'إرسال عبر واتساب',
    },
    errorModal: {
        title: 'حدث خطأ!',
        okay: 'حسناً',
    },
    language: {
        english: 'الإنجليزية',
        arabic: 'العربية',
        selectLanguage: 'اختر اللغة',
    },
    appAbout: {
        title: 'إنشاء متجر رقمي بسهولة',
        subtitle: 'أنشئ متجرك الرقمي بهوية علامتك التجارية. خصّص الألوان والفئات والشعار. أضف صفحات التواصل، من نحن، وخريطة الموقع. أنشئ رموز QR بشعارك. اجمع آراء الزبائن وأدر متجرك بسهولة. تمتّع بمستقبل من التصاميم والميزات المتقدّمة.',
    },
    appContact: {
        title: 'سجّل الآن',
        subtitle: 'أرسل لنا طلبك ونحن نتكفّل بالباقي — لنطلق نشاطك على الإنترنت',
        addressLabel: 'العنوان:',
        emailLabel: 'راسلنا عبر البريد:',
        phoneLabel: 'اتصل بنا:',
        whatsAppLabel: 'واتساب:',
        workingHoursLabel: 'ساعات العمل:',
    },
    appFeatures: {
        title: 'أطلق إمكانياتك',
        description: 'أنشئ متجرك الرقمي وأدره بسهولة مع ميزاتنا القوية',
        items: {
            designStore: {
                title: 'صمّم متجر أحلامك',
                description: 'اجعل متجرك الرقمي فريداً. خصّص كل التفاصيل، من الألوان والفئات إلى الترويسات والتذييلات وحتى شعارك الخاص.',
                keyPoints: {
                    theme: 'محرّر الألوان',
                    category: 'إدارة الفئات',
                    branding: 'التحكم بالهوية',
                },
            },
            completePresence: {
                title: 'حضور متكامل على الإنترنت',
                description: 'قدّم تجربة سلسة للزوّار عبر صفحات أساسية. أدر صفحة تواصل احترافية مع خريطة وصفحة "من نحن" تروي قصّة علامتك التجارية.',
                keyPoints: {
                    catalog: 'صفحة الكاتالوج',
                    about: 'صفحة من نحن',
                    contact: 'صفحة التواصل مع خريطة',
                },
            },
            growBusiness: {
                title: 'نمِّ أعمالك',
                description: 'تفاعل مع زبائنك وادفع نموك. أنشئ رموز QR للمشاركة بسهولة، واجمع تعليقات قيّمة لتحسين متجرك وعروضك.',
                keyPoints: {
                    qr: 'منشئ رموز QR',
                    feedback: 'تعليقات الزبائن',
                    visibility: 'تعزيز الظهور على الإنترنت',
                },
            },
            effortlessControl: {
                title: 'تحكّم بلا جهد',
                description: 'أدر متجرك الرقمي بسهولة. واجهتنا البسيطة تتيح لك تحديث المنتجات وإدارة المحتوى والحفاظ على سير متجرك بسلاسة.',
                keyPoints: {
                    ui: 'واجهة سهلة الاستخدام',
                    updates: 'تحديثات سلسة',
                    efficiency: 'وفّر الوقت والموارد',
                },
            },
        },
    },
    appDemo: {
        intro: 'اضغط هنا لمشاهدة',
        linkText: 'متجر رقمي مباشر',
    },
    appPricing: {
        title: 'باقات الاشتراك',
        description: 'أطلق العنان لإمكانيات متجرك الرقمي بأدوات وميزات مخصصة',
        firstYearType: 'سنوياً',
        popularBadge: 'الباقة الاحترافية',
        registerButton: 'سجّل',
        plans: {
            unlimited: {
                title: 'الباقة غير المحدودة',
                description: 'وصول كامل إلى الميزات الأساسية والإعداد والهوية لإطلاق متجرك الرقمي أو قائمتك على الإنترنت.',
                keyPoints: {
                    branch: 'فرع واحد',
                    products: 'منتجات وصور غير محدودة',
                    catalog: 'إدارة كاملة للكاتالوج',
                    branding: 'هوية مخصصة (شعار وألوان)',
                    qr: 'منشئ رموز QR ديناميكي',
                    pages: 'صفحات التواصل ومن نحن',
                    maps: 'دمج خرائط غوغل',
                    feedback: 'نظام تعليقات الزبائن',
                    social: 'مشاركة حسابات التواصل الاجتماعي',
                    support: 'دعم الزبائن',
                },
            },
            business: {
                title: 'باقة الأعمال',
                description: 'مثالية للمطاعم والمتاجر متعددة الفروع. ميزات متقدمة ومتابعة ذات أولوية.',
                keyPoints: {
                    branches: 'فروع متعددة',
                    products: 'منتجات وصور غير محدودة',
                    catalog: 'إدارة كاملة للكاتالوج',
                    branding: 'هوية مخصصة (شعار وألوان)',
                    qr: 'منشئ رموز QR ديناميكي',
                    pages: 'صفحات التواصل ومن نحن',
                    maps: 'دمج خرائط غوغل',
                    feedback: 'نظام تعليقات الزبائن',
                    social: 'مشاركة حسابات التواصل الاجتماعي',
                    prioritySupport: 'دعم ذو أولوية',
                },
            },
            vip: {
                title: 'باقة VIP المُدارة',
                description: 'نتولّى كل شيء بدلاً عنك — مثالية لمن يرغب بتجربة خالية من الأعباء. ركّز على أعمالك ونحن ندير وجودك الرقمي.',
                keyPoints: {
                    businessFeatures: 'كل ميزات باقة الأعمال',
                    management: 'إدارة كاملة للحساب (صور، أسعار، تحديث القائمة)',
                    optimization: 'نصائح واقتراحات للتحسين',
                    support: 'دعم ذو أولوية واستجابة سريعة',
                },
            },
            extraFeatures: {
                title: 'مميزات إضافية',
                description: 'إضافات اختيارية يمكنك تفعيلها في أي وقت لتوسيع متجرك.',
                keyPoints: {
                    menuSections: 'أقسام القائمة — 20$',
                    multiLanguage: 'تعدد اللغات — 20$',
                },
            },
        },
    },
    mainFooter: {
        copyrightSuffix: 'جميع الحقوق محفوظة.',
        poweredBy: 'مدعوم من Storec',
        addressLabel: 'العنوان:',
        phoneLabel: 'الهاتف:',
        workingHoursLabel: 'ساعات العمل:',
        contactInfoTitle: 'معلومات التواصل',
        quickLinksTitle: 'روابط سريعة',
    },
    banner: {
        contact: 'تواصل',
        about: 'من نحن',
        editImage: 'تعديل الصورة',
        deleteImage: 'حذف الصورة',
        addBannerImage: 'إضافة صورة للبانر',
        caption: 'التعليق',
        title: 'العنوان',
        imageCaption: 'تعليق الصورة',
        sectionTitle: 'عنوان القسم',
        pickImage: 'اختر صورة',
        imageRequired: 'يرجى تقديم صورة.',
        captionError: 'يرجى إدخال تعليق صالح.',
        titleError: 'يرجى إدخال عنوان صالح.',
        deleteConfirm: 'هل أنت متأكد؟',
        deleteQuestion: 'هل تريد المتابعة لحذف الصورة؟',
        addedSuccess: 'تمت إضافة عنصر البانر بنجاح.',
        updatedSuccess: 'تم تحديث الصورة بنجاح.',
        deletedSuccess: 'تم حذف الصورة بنجاح.',
    },
    adminSections: {
        sectionTitle: 'عنوان القسم',
        sectionDescription: 'وصف القسم',
        sectionDescription2: 'وصف القسم 2',
        buttonText: 'نص الزر',
        buttonLink: 'رابط الزر',
        sectionAvailable: 'القسم متاح',
        addImage: 'إضافة صورة',
        imageRequired: 'يرجى تقديم صورة.',
        titleError: 'يرجى إدخال عنوان صالح.',
        descriptionError: 'يرجى إدخال وصف صالح.',
        buttonTextError: 'يرجى إدخال نص زر صالح.',
        buttonLinkError: 'يرجى إدخال رابط زر صالح.',
        sectionUpdated: 'تم تحديث القسم بنجاح.',
        placeholders: {
            title: 'العنوان...',
            description: 'الوصف...',
            buttonText: 'نص الزر...',
            buttonLink: 'رابط الزر...',
        },
    },
    feedback: {
        addNew: 'إضافة تعليق جديد',
        addButton: 'إضافة تعليق',
        edit: 'تعديل التعليق',
        delete: 'حذف التعليق',
        sectionTitle: 'عنوان القسم',
        sectionAvailable: 'القسم متاح',
        available: 'متاح',
        nameLabel: '* الاسم',
        descriptionLabel: '* الوصف',
        emailLabel: '* البريد الإلكتروني',
        phoneLabel: 'الهاتف',
        feedbackStatus: '* حالة التعليق',
        feedbackAvailable: '* التعليق متاح',
        displayEmail: 'البريد الإلكتروني:',
        displayPhone: 'الهاتف:',
        statusAccepted: 'مقبول',
        statusPending: 'قيد الانتظار',
        statusRejected: 'مرفوض',
        deleteQuestion: 'هل تريد المتابعة لحذف الصورة؟',
        placeholders: {
            name: 'الاسم...',
            description: 'الوصف...',
            email: 'البريد الإلكتروني...',
            phone: 'الهاتف...',
            title: 'العنوان...',
        },
        errors: {
            name: 'يرجى إدخال اسم صالح.',
            description: 'يرجى إدخال وصف صالح.',
            email: 'يرجى إدخال بريد إلكتروني صالح.',
            phone: 'يرجى إدخال رقم هاتف.',
            title: 'يرجى إدخال عنوان صالح.',
        },
        messages: {
            sectionUpdated: 'تم تحديث القسم بنجاح.',
            added: 'تمت إضافة التعليق بنجاح.',
            selected: 'تم اختيار التعليق بنجاح.',
            updated: 'تم تحديث التعليق بنجاح.',
            deleted: 'تم حذف التعليق بنجاح.',
        },
    },
    homeFeedback: {
        title: 'آراء الزبائن',
    },
    contactSection: {
        title: 'شاركنا رأيك',
        subtitle: 'أخبرنا عن تجربتك مع متجرنا. آراؤك تساعدنا على التحسّن',
        sectionSubtitleLabel: 'عنوان فرعي للقسم',
        subtitleError: 'يرجى إدخال عنوان فرعي صالح.',
        subtitlePlaceholder: 'العنوان الفرعي...',
    },
    contactFeedbackForm: {
        namePlaceholder: '* اسمك',
        emailPlaceholder: '* بريدك الإلكتروني',
        phonePlaceholder: 'رقم هاتفك',
        feedbackLabel: '* تعليقك',
        nameError: 'يرجى إدخال اسمك.',
        emailError: 'يرجى إدخال بريد إلكتروني صالح.',
        phoneError: 'يرجى إدخال رقم هاتف.',
        feedbackError: 'يرجى إدخال تعليقك.',
    },
    contactInfoAdmin: {
        emailPlaceholder: '* بريد المتجر',
        phonePlaceholder: '* هاتف المتجر',
        whatsappPlaceholder: '* واتساب المتجر',
        workingHoursPlaceholder: '* ساعات العمل',
        addressLabel: '* عنواننا',
        addressPlaceholder: '* العنوان',
        emailError: 'يرجى إدخال بريد إلكتروني صالح.',
        phoneError: 'يرجى إدخال رقم هاتف.',
        whatsappError: 'يرجى إدخال معرف واتساب صالح.',
        workingHoursError: 'يرجى إدخال ساعات العمل.',
        addressError: 'يرجى إدخال عنوان المطعم.',
        successMessage: 'تمت إضافة معلومات التواصل بنجاح.',
    },
    contactMap: {
        mapTitle: 'خريطة موقع المتجر',
    },
    contactStoreDetails: {
        addressLabel: 'زرنا:',
        emailLabel: 'راسلنا عبر البريد:',
        phoneLabel: 'اتصل بنا:',
        whatsAppLabel: 'واتساب:',
        workingHoursLabel: 'ساعات العمل:',
    },
    aboutSection: {
        title: 'من نحن',
    },
    nav: {
        store: 'المتجر',
        stores: 'المتاجر',
        contact: 'تواصل',
        about: 'من نحن',
        features: 'الميزات',
        pricing: 'الأسعار',
        demo: 'العرض',
        joinUs: 'انضم إلينا',
        login: 'تسجيل الدخول',
        logout: 'تسجيل الخروج',
        profile: 'الملف الشخصي',
        details: 'التفاصيل',
        theme: 'الهوية',
        qrBuilder: 'منشئ QR',
        settings: 'الإعدادات',
    },
    auth: {
        paymentDue: 'الدفع مستحق.',
        emailPlaceholder: 'البريد الإلكتروني',
        passwordPlaceholder: 'كلمة المرور',
        emailRequired: 'يرجى إدخال بريدك الإلكتروني!',
        emailInvalid: 'يرجى إدخال بريد إلكتروني صالح!',
        passwordRequired: 'يرجى إدخال كلمة المرور!',
        signIn: 'تسجيل الدخول',
        notRegistered: 'لست مسجَّلاً؟',
    },
    registerForm: {
        storeNamePlaceholder: '* اسم المتجر',
        emailPlaceholder: '* بريدك الإلكتروني',
        phonePlaceholder: '* رقم هاتفك',
        nameError: 'يرجى إدخال اسمك.',
        emailError: 'يرجى إدخال بريد إلكتروني صالح.',
        phoneError: 'يرجى إدخال رقم هاتف صالح.',
        submit: 'إرسال',
        successMessage: 'تم إرسال طلب الانضمام بنجاح. سنتواصل معك قريباً.',
    },
    addStore: {
        title: 'إضافة متجر',
        previous: 'السابق',
        upload: 'رفع',
        register: 'تسجيل',
        successMessage: 'تم التسجيل بنجاح',
        fields: {
            ownerName: 'اسم المالك',
            username: 'اسم المستخدم',
            email: 'البريد الإلكتروني',
            phone: 'الهاتف',
            password: 'كلمة المرور',
            role: 'الدور',
            profileImage: 'الصورة الشخصية',
        },
        errors: {
            ownerNameRequired: 'يرجى إدخال اسم المالك!',
            usernameRequired: 'يرجى إدخال اسم مستخدم المتجر!',
            emailRequired: 'يرجى إدخال بريد المالك!',
            emailInvalid: 'يرجى إدخال بريد إلكتروني صالح!',
            phoneRequired: 'يرجى إدخال هاتف المالك!',
            passwordRequired: 'يرجى إدخال كلمة مرور المتجر!',
            passwordMin: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل!',
            roleRequired: 'يرجى إدخال الدور!',
        },
        roles: {
            store: 'متجر',
        },
    },
    qrCode: {
        previous: 'السابق',
        upload: 'رفع',
        download: 'تنزيل رمز QR',
        generatedTitle: 'رمز QR المُنشأ',
        cards: {
            colors: 'تعديل ألوان QR',
            shapes: 'تعديل شكل QR',
            logo: 'رفع شعار المتجر',
        },
        fields: {
            dotsColor: 'لون النقاط',
            cornersSquareColor: 'لون مربعات الزوايا',
            cornersDotColor: 'لون نقاط الزوايا',
            qrShape: 'شكل QR',
            dotsStyle: 'شكل النقاط',
            cornersSquareStyle: 'شكل مربعات الزوايا',
            cornersDotStyle: 'شكل نقاط الزوايا',
            storeLogo: 'شعار المتجر',
        },
        shapes: {
            square: 'مربع',
            circle: 'دائرة',
            dot: 'نقطة',
            rounded: 'مدوّر',
            dots: 'نقاط',
            classy: 'أنيق',
            'classy-rounded': 'أنيق مدوّر',
            'extra-rounded': 'مدوّر إضافي',
        },
        errors: {
            generate: 'تعذّر إنشاء رمز QR. حاول لاحقاً أو تواصل مع دعم Storec.',
        },
    },
    themeEditor: {
        title: 'تعديل الهوية',
        previous: 'السابق',
        mainColor: 'اللون الرئيسي',
        secondaryColor: 'اللون الثانوي',
        saveChanges: 'حفظ التغييرات',
        changedSuccess: 'تم تغيير الهوية بنجاح',
    },
    storeSettings: {
        title: 'إعدادات المتجر',
        previous: 'السابق',
        fields: {
            sectionsEnabled: 'أقسام المتجر',
            multiLanguageEnabled: 'دعم تعدد اللغات',
            defaultLanguage: 'اللغة الافتراضية',
        },
        updatedTemplate: 'تم تحديث {label} بنجاح',
    },
    storeDetails: {
        title: 'تفاصيل المتجر',
        previous: 'السابق',
        upload: 'رفع',
        successMessage: 'تم الإرسال بنجاح',
        info: {
            storeUsername: 'اسم مستخدم المتجر:',
            storeOwner: 'مالك المتجر:',
            ownerEmail: 'بريد المالك:',
        },
        fields: {
            name: 'اسم المتجر',
            description: 'وصف المتجر',
            address: 'العنوان النصي',
            addressLink: 'رابط العنوان',
            embedAddressLink: 'رابط العنوان المضمّن',
            email: 'بريد المتجر',
            phone: 'هاتف المتجر',
            whatsapp: 'رقم واتساب',
            instagram: 'رابط إنستغرام',
            facebook: 'رابط فيسبوك',
            twitter: 'رابط تويتر',
            linkedin: 'رابط لينكدإن',
            youtube: 'رابط يوتيوب',
            tiktok: 'رابط تيك توك',
            workingHours: 'ساعات العمل',
            currency: 'العملة',
            image: 'صورة المتجر',
            backgroundImage: 'صورة الخلفية',
        },
        errors: {
            name: 'يرجى إدخال اسم المتجر!',
            description: 'يرجى إدخال وصف المتجر!',
            address: 'يرجى إدخال عنوان المتجر!',
            addressLink: 'يرجى إدخال رابط العنوان!',
            embedAddressLink: 'يرجى إدخال رابط العنوان المضمّن!',
            email: 'يرجى إدخال بريد المتجر!',
            phone: 'يرجى إدخال هاتف المتجر!',
            whatsapp: 'يرجى إدخال واتساب المتجر!',
            instagram: 'يرجى إدخال إنستغرام المتجر!',
            facebook: 'يرجى إدخال فيسبوك المتجر!',
            twitter: 'يرجى إدخال تويتر المتجر!',
            linkedin: 'يرجى إدخال لينكدإن المتجر!',
            youtube: 'يرجى إدخال يوتيوب المتجر!',
            tiktok: 'يرجى إدخال تيك توك المتجر!',
            workingHours: 'يرجى إدخال ساعات العمل!',
            currency: 'يرجى اختيار عملة!',
            image: 'يرجى رفع صورة المتجر!',
            backgroundImage: 'يرجى رفع صورة الخلفية!',
        },
        currencies: {
            usd: 'USD (الدولار الأمريكي)',
            lbp: 'LBP (الليرة اللبنانية)',
            iqd: 'IQD (الدينار العراقي)',
            sar: 'SAR (الريال السعودي)',
            kwd: 'KWD (الدينار الكويتي)',
            omr: 'OMR (الريال العُماني)',
            qar: 'QAR (الريال القطري)',
            syp: 'SYP (الليرة السورية)',
            jod: 'JOD (الدينار الأردني)',
            egp: 'EGP (الجنيه المصري)',
        },
    },
    userProfile: {
        editTitle: 'تعديل المعلومات',
        profileTitle: 'معلومات الملف الشخصي',
        previous: 'السابق',
        upload: 'رفع',
        editButton: 'تعديل المعلومات',
        successMessage: 'تم تحديث المعلومات بنجاح',
        fields: {
            ownerName: 'اسم المالك',
            ownerEmail: 'بريد المالك',
            ownerPhone: 'هاتف المالك',
            profileImage: 'صورة الملف الشخصي',
        },
        errors: {
            ownerNameRequired: 'يرجى إدخال اسم المالك!',
            ownerEmailRequired: 'يرجى إدخال بريد المالك!',
            ownerEmailInvalid: 'يرجى إدخال بريد إلكتروني صالح!',
            ownerPhoneRequired: 'يرجى إدخال هاتف المالك!',
        },
        resetPassword: {
            title: 'إعادة تعيين كلمة المرور',
            newPassword: 'كلمة المرور الجديدة',
            confirmPassword: 'تأكيد كلمة المرور',
            submit: 'إعادة التعيين',
            mismatch: 'كلمتا المرور غير متطابقتين',
            successMessage: 'تمت إعادة تعيين كلمة المرور بنجاح',
            errors: {
                newPasswordRequired: 'يرجى إدخال كلمة مرور جديدة!',
                confirmPasswordRequired: 'يرجى تأكيد كلمة المرور الجديدة!',
                passwordMin: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل!',
            },
        },
        changePassword: {
            title: 'تغيير كلمة المرور',
            currentPassword: 'كلمة المرور الحالية',
            newPassword: 'كلمة المرور الجديدة',
            confirmPassword: 'تأكيد كلمة المرور',
            submit: 'إرسال',
            mismatch: 'كلمتا المرور غير متطابقتين',
            samePassword: 'يجب أن تكون كلمة المرور الجديدة مختلفة عن الحالية',
            successMessage: 'تم تغيير كلمة المرور بنجاح',
            errors: {
                currentPasswordRequired: 'يرجى إدخال كلمة المرور الحالية!',
                newPasswordRequired: 'يرجى إدخال كلمة مرور جديدة!',
                confirmPasswordRequired: 'يرجى تأكيد كلمة المرور الجديدة!',
                passwordMin: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل!',
            },
        },
    },
    signupForm: {
        title: 'نموذج التسجيل',
        userName: 'اسم المستخدم',
        username: 'اسم المستخدم (Username)',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        password: 'كلمة المرور',
        role: 'الدور',
        profileImage: 'صورة الملف الشخصي',
        upload: 'رفع',
        signUp: 'تسجيل',
        successMessage: 'تم التسجيل بنجاح',
        roles: {
            store: 'متجر',
        },
        errors: {
            userNameRequired: 'يرجى إدخال اسم المستخدم!',
            usernameRequired: 'يرجى إدخال اسم المستخدم (Username)!',
            emailRequired: 'يرجى إدخال البريد الإلكتروني!',
            emailInvalid: 'يرجى إدخال بريد إلكتروني صالح!',
            phoneRequired: 'يرجى إدخال رقم الهاتف!',
            passwordRequired: 'يرجى إدخال كلمة المرور!',
            passwordMin: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل!',
            roleRequired: 'يرجى اختيار دور!',
        },
    },
    menu: {
        allCategories: 'كل الفئات',
        sectionsLabel: 'الأقسام',
        emptyItems: 'لا توجد عناصر للعرض!',
        emptySections: 'لا توجد أقسام متجر للعرض!',
        messages: {
            categoriesSorted: 'تم ترتيب الفئات بنجاح.',
            categorySortFailed: 'فشل ترتيب الفئات، يرجى المحاولة لاحقاً.',
            storeSectionsSorted: 'تم ترتيب أقسام المتجر بنجاح.',
            storeSectionSortFailed: 'فشل ترتيب أقسام المتجر، يرجى المحاولة لاحقاً.',
            productsSorted: 'تم ترتيب المنتج بنجاح.',
            productSortFailed: 'فشل ترتيب المنتج، يرجى المحاولة لاحقاً.',
            categoryDeleted: 'تم حذف الفئة بنجاح.',
            categoryDeleteFailed: 'فشل حذف الفئة، يرجى المحاولة لاحقاً.',
            categoryUpdated: 'تم تحديث الفئة بنجاح.',
            categoryUpdateFailed: 'فشل تحديث الفئة، يرجى المحاولة لاحقاً.',
            categoryAdded: 'تمت إضافة الفئة بنجاح.',
            categoryAddFailed: 'فشلت إضافة الفئة، يرجى المحاولة لاحقاً.',
            productAdded: 'تمت إضافة المنتج بنجاح.',
            productAddFailed: 'فشلت إضافة المنتج، يرجى المحاولة لاحقاً.',
            productDeleted: 'تم حذف المنتج بنجاح.',
            productDeleteFailed: 'فشل حذف المنتج، يرجى المحاولة لاحقاً.',
            productUpdated: 'تم تحديث المنتج بنجاح.',
            productUpdateFailed: 'فشل تحديث المنتج، يرجى المحاولة لاحقاً.',
            sizeDeleted: 'تم حذف القياس بنجاح.',
            sizeDeleteFailed: 'فشل حذف القياس، يرجى المحاولة لاحقاً.',
            sizeAdded: 'تمت إضافة قياس جديد بنجاح.',
            sizeAddFailed: 'فشلت إضافة القياس، يرجى المحاولة لاحقاً.',
            sectionDeleted: 'تم حذف قسم المتجر بنجاح.',
            sectionDeleteFailed: 'فشل حذف قسم المتجر، يرجى المحاولة لاحقاً.',
            sectionUpdated: 'تم تحديث قسم المتجر بنجاح.',
            sectionUpdateFailed: 'فشل تحديث قسم المتجر، يرجى المحاولة لاحقاً.',
            sectionAdded: 'تمت إضافة القسم بنجاح.',
            sectionAddFailed: 'فشلت إضافة القسم، يرجى المحاولة لاحقاً.',
        },
        actions: {
            addNewCategory: 'إضافة فئة جديدة',
            addNewSection: 'إضافة قسم جديد',
            addCategory: 'إضافة فئة',
            addSection: 'إضافة قسم',
            editCategory: 'تعديل الفئة',
            editSection: 'تعديل قسم المتجر',
            addItem: 'إضافة عنصر',
            addNewItem: 'إضافة عنصر جديد',
            addNewSize: 'إضافة قياس جديد',
            editItem: 'تعديل العنصر',
            reset: 'إعادة تعيين',
            deleteSize: 'حذف القياس',
            deleteProduct: 'حذف المنتج',
            cancelDeletion: 'إلغاء الحذف',
        },
        fields: {
            name: 'الاسم',
            description: 'الوصف',
            price: 'السعر',
            size: 'القياس',
            imageCaption: 'تعليق الصورة',
            itemAvailable: 'العنصر متاح',
        },
        placeholders: {
            categoryName: 'اسم الفئة',
            sectionName: 'اسم القسم',
            itemName: 'اسم العنصر',
            itemDescription: 'وصف العنصر',
            itemPrice: 'سعر العنصر',
            caption: 'تعليق',
        },
        errors: {
            title: 'يرجى إدخال عنوان صالح.',
            description: 'يرجى إدخال وصف صالح.',
            price: 'يرجى إدخال سعر صالح.',
            caption: 'يرجى إدخال تعليق صالح للصورة.',
            imageRequired: 'يرجى تقديم صورة.',
        },
        confirm: {
            areYouSure: 'هل أنت متأكد؟',
            deleteCategory: 'هل تريد المتابعة لحذف الفئة؟',
            deleteSection: 'هل تريد المتابعة لحذف قسم المتجر؟',
            deleteProduct: 'هل تريد المتابعة لحذف المنتج',
            orSize: 'أو القياس',
        },
        sizes: {
            none: 'بدون',
            small: 'صغير',
            medium: 'وسط',
            large: 'كبير',
            family: 'عائلي',
            regular: 'عادي',
            mashrouha: 'مشروحة',
        },
        media: {
            upload: 'رفع',
            pickImage: 'اختر صورة',
            bannerAlt: 'بانر المتجر',
            storeAlt: 'المتجر',
        },
    },
    storeList: {
        searchPlaceholder: 'ابحث عن متجر',
        filters: {
            registered: 'المسجَّلون',
            unregistered: 'غير المسجَّلين',
        },
        statuses: {
            unsubscribed: 'غير مشترك',
            duePayment: 'دفعة مستحقة',
            active: 'نشط',
            restrictedTag: 'مقيَّد',
        },
        menu: {
            restrictStore: 'تقييد المتجر',
            unRestrictStore: 'إلغاء تقييد المتجر',
            setPaidDate: 'تحديد تاريخ الدفع',
            add: 'إضافة',
        },
        actions: {
            restrict: 'تقييد',
            unRestrict: 'إلغاء التقييد',
        },
        confirm: {
            areYouSure: 'هل أنت متأكد؟',
            restrict: 'هل تريد المتابعة لـ {action} المتجر {store}',
            payment: 'هل تريد المتابعة لتحديد تاريخ الدفع؟',
            setDate: 'تحديد التاريخ',
            cancel: 'إلغاء',
        },
        errors: {
            storeNotFound: 'المتجر غير موجود!',
        },
        messages: {
            restrictSuccess: 'تم تحديث المتجر بنجاح.',
            paymentSuccess: 'تم تحديد تاريخ الدفع بنجاح.',
        },
    },
};

export default ar;
